import { render } from "./ClientServiceTxlStation.vue?vue&type=template&id=0580bc72&scoped=true&ts=true"
import script from "./clientServiceStationTxlHelper.ts?vue&type=script&lang=ts"
export * from "./clientServiceStationTxlHelper.ts?vue&type=script&lang=ts"

import "./ClientServiceTxlStation.vue?vue&type=style&index=0&id=0580bc72&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0580bc72"]])

export default __exports__